import { render } from "./External.vue?vue&type=template&id=3c7ec914&scoped=true"
import script from "./External.vue?vue&type=script&lang=js"
export * from "./External.vue?vue&type=script&lang=js"

import "./External.vue?vue&type=style&index=0&id=3c7ec914&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c7ec914"

export default script